import emailjs from '@emailjs/browser'
import { emailConfig } from '../config/email'

/**
 * Send email using EmailJS
 * @param {string} templateId - Template ID from emailConfig.templates
 * @param {object} templateParams - Template parameters (name, email, message, etc.)
 * @returns {Promise} EmailJS send promise
 */
export const sendEmail = async (templateId, templateParams) => {
    try {
        // Check if EmailJS is configured
        if (emailConfig.publicKey === 'YOUR_PUBLIC_KEY' || 
            emailConfig.serviceId === 'YOUR_SERVICE_ID' ||
            templateId === 'YOUR_TEMPLATE_ID') {
            throw new Error('EmailJS is not configured. Please update src/config/email.js with your EmailJS credentials.')
        }

        // Initialize EmailJS with public key
        emailjs.init(emailConfig.publicKey)

        // Send email
        const response = await emailjs.send(
            emailConfig.serviceId,
            templateId,
            templateParams
        )

        return {
            success: true,
            message: 'Email sent successfully!',
            response
        }
    } catch (error) {
        return {
            success: false,
            message: error.text || error.message || 'Failed to send email. Please try again.',
            error
        }
    }
}

/**
 * Send contact form email
 * @param {object} formData - { name, email, phone, institution?, interestedProducts?, message, tourType? }
 */
export const sendContactEmail = async (formData) => {
    const templateParams = {
        to_email: emailConfig.toEmail,
        from_name: formData.name,
        from_email: formData.email || '',
        phone: formData.phone || '',
        institution: formData.institution || '',
        interested_products: formData.interestedProducts || '',
        message: formData.message,
        tour_type: formData.tourType || '',
        reply_to: formData.email || ''
    }

    return await sendEmail(emailConfig.templates.contact, templateParams)
}

/**
 * Send book tour form email
 * @param {object} formData - { name, email, tourType, message }
 * DISABLED: Using only contact form
 */
export const sendBookTourEmail = async (formData) => {
    return {
        success: false,
        message: 'Bu form şu anda devre dışı. Lütfen iletişim sayfasındaki formu kullanın.'
    }
    
    // Disabled code:
    // const templateParams = {
    //     to_email: emailConfig.toEmail,
    //     from_name: formData.name,
    //     from_email: formData.email,
    //     tour_type: formData.tourType || '',
    //     message: formData.message || '',
    //     reply_to: formData.email
    // }
    // return await sendEmail(emailConfig.templates.bookTour, templateParams)
}

/**
 * Send FAQ contact form email
 * @param {object} formData - { name, email, message }
 * DISABLED: Using only contact form
 */
export const sendFaqEmail = async (formData) => {
    return {
        success: false,
        message: 'Bu form şu anda devre dışı. Lütfen iletişim sayfasındaki formu kullanın.'
    }
    
    // Disabled code:
    // const templateParams = {
    //     to_email: emailConfig.toEmail,
    //     from_name: formData.name,
    //     from_email: formData.email,
    //     message: formData.message,
    //     reply_to: formData.email
    // }
    // return await sendEmail(emailConfig.templates.faq, templateParams)
}

/**
 * Send newsletter subscription email
 * @param {string} email - Subscriber email
 * DISABLED: Using only contact form
 */
export const sendNewsletterEmail = async (email) => {
    return {
        success: false,
        message: 'Newsletter aboneliği şu anda devre dışı. Lütfen iletişim sayfasındaki formu kullanın.'
    }
    
    // Disabled code:
    // const templateParams = {
    //     to_email: emailConfig.toEmail,
    //     subscriber_email: email,
    //     reply_to: email
    // }
    // return await sendEmail(emailConfig.templates.newsletter, templateParams)
}


